import React from 'react';
import { Grid } from '@material-ui/core';
import { PortalButton } from 'src/components/Buttons/PortalButton';
import { Config } from 'src/state/Config';
import { t } from 'i18next';
import { onHandleKeyDown } from 'src/utils/onHandleKeyDown';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';

interface IModalMenu {
  onConfirm?: () => void;
  onCancel?: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  isSuccessDialog?: boolean;
  isConfirmationDialog?: boolean;
}

const ModalMenu = ({
  isConfirmationDialog,
  isSuccessDialog,
  onConfirm,
  onCancel,
}: IModalMenu) => {
  const isFromMvpApp = useUrlParameterCheck('/app');
  const rejectButtonType = Config.isRealkreditDenmark()
    ? 'primary'
    : 'secondary';

  const containerStyle = isFromMvpApp
    ? {
        display: 'flex',
        flexDirection: 'column-reverse',
      }
    : undefined;

  const fontWeightStyle = isFromMvpApp
    ? { fontWeight: 600 }
    : { fontWeight: 400 };

  const displayText =
    isSuccessDialog || isConfirmationDialog ? t('Close') : t('No');

  return (
    <Grid container wrap="wrap" spacing={2} style={containerStyle as any}>
      <Grid item xs={isFromMvpApp ? 12 : 6} sm={isFromMvpApp ? 12 : 6}>
        <PortalButton
          onKeyDown={e => onHandleKeyDown(e, onCancel)}
          onClick={onCancel}
          colorType={isFromMvpApp ? 'mvpGray' : rejectButtonType}
          fullWidth
          style={{
            fontWeight: fontWeightStyle,
            color: isFromMvpApp && '#002346',
          }}
          isFromMvpApp={isFromMvpApp}
        >
          {displayText}
        </PortalButton>
      </Grid>
      {isSuccessDialog || isConfirmationDialog ? null : (
        <Grid item xs={isFromMvpApp ? 12 : 6} sm={isFromMvpApp ? 12 : 6}>
          <PortalButton
            onKeyDown={e => onHandleKeyDown(e, onConfirm)}
            onClick={onConfirm}
            colorType={isFromMvpApp ? 'mvpRed' : 'primary'}
            fullWidth
            style={{ fontWeight: fontWeightStyle }}
            isFromMvpApp={isFromMvpApp}
          >
            {t('Yes')}
          </PortalButton>
        </Grid>
      )}
    </Grid>
  );
};

export default ModalMenu;
